// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__7m4lt","content":"styles_content__3xL91","selectAll":"styles_selectAll__3t0Qz"};